/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_Order_NoInputs */

const en_settings_payments_order_no = /** @type {(inputs: Settings_Payments_Order_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order`)
};

/**
* | output |
* | --- |
* | "Order" |
*
* @param {Settings_Payments_Order_NoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_payments_order_no = /** @type {((inputs?: Settings_Payments_Order_NoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_Order_NoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_payments_order_no(inputs)
});
export { settings_payments_order_no as "settings.payments.order_no" }